<template>
  <div id="boolean-v1-u47f4h">
    <b-form-group id="boolean-v1-cegb9t" v-if="showType == 'form-builder'" :style="properties.style">
      <b-form-checkbox id="boolean-v1-w77w5a">{{
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      }}</b-form-checkbox>
    </b-form-group>
    <div id="boolean-v1-gau2cs" v-if="showType == 'properties'">
      <boolean-v1-properties id="boolean-v1-oh8p6h" :formId="formId" />
    </div>
    <b-form-group :id="'boolean-v1-84snke' + id"
      style="font-size: 14px"
      v-show="!computedHidden"
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :style="properties.style"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <b-form-checkbox :id="'boolean-v1-ekm00y' + id" v-model="controlValue" style="font-size: 14px">{{
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      }}</b-form-checkbox>
    </b-form-group>
    <b-form-group id="boolean-v1-jorre8"
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
    >
      <div id="boolean-v1-bp0fck">
        <b-icon-check-square-fill id="boolean-v1-43tz8q"
          class="text-primary"
          v-if="controlValue"
        /><b-icon-square id="boolean-v1-6jz0lp" v-else />
        {{
          computedConditions.label
            ? computedPropertiesForm.label
            : properties.label
        }}
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import BooleanV1Properties from "./BooleanV1Properties.vue";
export default {
  name: "BooleanV1",
  components: { BooleanV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: ["label", "hidden"],
      computedConditions: {}
    };
  },
  mounted() {
    if (this.showType == "form-submitter" || this.showType == "e-form") {
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          label: this.properties.label
        }
      });
      if(this.componentsIdSuffix) {
        this.initializeComponentValue({
          controlId: this.id,
          properties: this.properties
        });
      }
    }
    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentMetadata"]),
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );
      const hideOnView = this.getComponentComputedProperties(
        "hideOnView"
      );

      if(hidden === true || hideOnView)
        return "";

      return `
      <fieldset aria-describedby="" class="form-group">
        <div style="font-size: 14px" tabindex="-1" role="group" class="bv-no-focus-ring">
          ${
            this.controlValue
              ? '<i class="fas fa-check-square text-primary"></i>'
              : '<i class="far fa-square"></i>'
          }
          ${this.getComponentComputedProperties("label")}
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true,
            hardSet: this.properties.resetStoreValues
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>
